// Gallery "Tính năng huyền thoại": video chính (Swiper) điều khiển bởi
// Swiper thumbnail + pagination (chấm sao) + nút prev/next.
window.addEventListener("load", function () {
  if (typeof Swiper === "undefined") return;
  if (!document.querySelector("#gallery .swiper-main")) return;

  // Swiper thumbnail: cuộn ngang, dùng chính ảnh video (scale nhỏ)
  var thumbs = new Swiper("#gallery .swiper-thumb", {
    slidesPerView: "auto",
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      769: { spaceBetween: 8 },
    },
  });

  // Video chính: fade, điều khiển bởi thumbs + pagination + navigation
  new Swiper("#gallery .swiper-main", {
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 500,
    pagination: {
      el: "#gallery .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: "#gallery .swiper-button-next",
      prevEl: "#gallery .swiper-button-prev",
    },
    thumbs: { swiper: thumbs },
  });

  // Nút "Thông tin": bật/tắt footer trượt lên đè đáy gallery.
  var btnInfo = document.querySelector("#gallery .btn-thongtin");
  var footer = document.querySelector("#gallery .footer");
  if (btnInfo && footer) {
    btnInfo.addEventListener("click", function (e) {
      e.preventDefault();
      footer.classList.toggle("is-show");
    });
  }
});
